const s = require("./monitoring.module.scss");

import { default as React, useEffect, useState } from "react";
import { withTranslation, WithTranslation } from "react-i18next";
import httpService from "core/infrastructure/http";
import { MonitoringDto, GetMonitoringDataResponse, GetMonitoringDataQuery } from "core/backend/common";
import SheetDataPart from "components/sheetDataPart";
import SheetHeader from "components/sheetHeader";
import { ApplicationState } from "core/app";
import { keys } from "ts-transformer-keys";
import List from "./list";
import { NavLink } from "react-router-dom";
import { faCog } from "@fortawesome/free-solid-svg-icons";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { PageList, sortParameters } from "core/pages/pageList";


interface OwnState {
    applicationState: ApplicationState;
}

export const senderId = "monitoring";

export const page_config: PageList =
{
    apiUrl: "monitoring",
    webUrl: "monitoring",
    menu: "", //no menu link should be created for this page
    apiType: "system",
    title: "common:titleMonitoring",
    response: JSON.stringify(keys<GetMonitoringDataResponse>()),
    dto: JSON.stringify(keys<MonitoringDto>()),
    parameters: JSON.stringify(sortParameters(keys<GetMonitoringDataQuery>())),
    dateSteps: "D",
    getDefaultToDateTime: (applicationState: ApplicationState) => applicationState.getUntilFor1Day()
};
type PageProps = OwnState & WithTranslation;

const Page = ({ t, applicationState }: PageProps) => {

    const initialData: MonitoringDto[] = [];
    const [data, setData] = useState(initialData);
    const [isLoading, setLoading] = useState(false);
    const [error, setError] = useState("");

    useEffect(() => {
        (async function runAsync() {
            applicationState.handleInputAvailablilityChange(page_config.dateSteps, false, false, keys<MonitoringDto>());
            setLoading(true);
            setData([]);
            const response = await httpService.apiPost<GetMonitoringDataResponse>({
                applicationState: applicationState,
                route: applicationState.apiService + "/" + page_config.apiType + "/" + page_config.apiUrl,
                query: {
                    FromUtc: applicationState.getRootUtcTime().toISOString(),
                    ToUtc: page_config.getDefaultToDateTime(applicationState).toISOString()
                },
                senderId: senderId
            })();

            if (response.ok) {
                setData(response.data.data);
                setError("");
            } else {
                setError(response.error || t("common:UnknownError"));
            }
            setLoading(false);
        })();
    }, [applicationState.selectedDate, applicationState.horizon]);

    const dataForHorizon = data.filter(f => f.page.toUpperCase().startsWith(applicationState.horizon.toUpperCase()));
    return (
        <>
            <SheetHeader showDownload={true} downloadFormats={['csv']} applicationState={applicationState} title={t(page_config.title) + " for " + applicationState.horizon.toUpperCase() } pageConfig={page_config} />
            {
                applicationState.userRole === "Licquid"
                    || applicationState.userRole === "JaoUser"
                    || applicationState.userRole === "JaoAdmin"
                    ? <div className="subHeader">
                        <NavLink to={"/monitoring"} activeClassName={s.selected} className={s.selectableTabs}>Overview per BusinessDay</NavLink>
                        <NavLink to={"/monitoringFailed"} activeClassName={s.selected} className={s.selectableTabs}>Failed Files</NavLink>
                        <NavLink to={"/monitoringConfig"} activeClassName={s.selected} className={s.selectableTabs}><FontAwesomeIcon icon={faCog} /> Configure</NavLink>
                    </div>
                    : ""
            }
            <SheetDataPart isLoading={isLoading} data={dataForHorizon} error={error}>
                <List data={dataForHorizon} applicationState={applicationState} />
            </SheetDataPart>
        </>

    );
}

export default withTranslation("monitoring")(Page);
